import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddMetadataExplainationPopupComponent } from '../add-metadata-explaination-popup/add-metadata-explaination-popup.component';
import { CopyFeedbackPopupComponent } from '../../../../shared/components/copy-feedback-popup/copy-feedback-popup.component';

@Component({
  selector: 'gdp-offer-link',
  templateUrl: './offer-link.component.html',
  styleUrls: ['./offer-link.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferLinkComponent implements OnInit {
  @ViewChild('couponMetadataPopup', { static: false }) couponMetadataPopup: CopyFeedbackPopupComponent;
  @ViewChild('offerLinkPopup', { static: false }) offerLinkPopup: CopyFeedbackPopupComponent;

  public modalValues = {
    content: ''
  }

  constructor(private modalService: NgbModal, private activeModal: NgbActiveModal) { }

  ngOnInit() {}

  generateMetadata(value) {
    const modal = this.modalService.open(this.couponMetadataPopup, { size: 'lg' });
    this.modalValues.content = value;
  }

  generateLink(value) {
    const modal = this.modalService.open(this.offerLinkPopup, { size: 'lg' });
    this.modalValues.content = value;
  }

  openAddMetadataPopup() {
    const modal = this.modalService.open(AddMetadataExplainationPopupComponent, { size: 'lg' });
  }

}
